import { Trans } from '@lingui/macro';
import { getMsgTypeCapitalized, Type } from 'bukku/redux/Transaction/helper';
import React from 'react';

export function getNameFromTransactionType(transactionType) {
    let name, label;
    switch (transactionType) {
        case Type.stock_adjustment:
            name = 'stock_adjustment_form_design_id';
            label = getMsgTypeCapitalized(transactionType);
            break;
        case 'statement':
            name = 'statement_form_design_id';
            label = <Trans>Statement of Account</Trans>;
            break;
        default:
            name = `${transactionType}_form_design_id`;
            label = getMsgTypeCapitalized(transactionType);
            break;
    }
    return {name, label};
}

// reorder form designs array so that the default design is at 0th index
export function getReorderedFormDesign(transactionType, settings, formDesigns) {
    // Fallback
    if (!transactionType)
        return formDesigns;

    const designFormName = getNameFromTransactionType(transactionType).name;
    // console.log('aaa renderMenu1', {transactionType, designFormName});
    const defaultDesignId = settings[designFormName];
    // console.log('aaa renderMenu2', {defaultDesignId});
    const index = formDesigns.findIndex(d => d.id === defaultDesignId);

    if (index !== -1) {
        // console.log('aaa renderMenu3', {index, formDesigns, defaultDesignName: formDesigns[index]?.name});
        const reorderedDesigns = [...formDesigns];
        // console.log('aaa renderMenu4', reorderedDesigns);
        const defaultFormDesign = reorderedDesigns.splice(index, 1);
        defaultFormDesign[0].is_default = true;
        // defaultFormDesign.name = `${defaultFormDesign.name} (Default)`;
        // console.log('aaa renderMenu5', {defaultFormDesign});
        reorderedDesigns.unshift(...defaultFormDesign);
        // console.log('aaa renderMenu6', reorderedDesigns);
        return reorderedDesigns;
    }
    return formDesigns;
}
